import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class UuidInput extends TextInput {}

registerCustomElement('imt-input-uuid', UuidInput);
